import { styled } from "@mui/material/styles";

export const AppContainer = styled("div", {
  shouldForwardProp: (prop) => prop !== "showFooter",
})(({ theme, showFooter }) => ({
  display: "flex",
  backgroundColor: theme.palette.background.primary,
  flexDirection: "column",
  height: "100%",
  paddingBottom: !showFooter ? "0" : "20px",

  "& .toolbar-container": {
    minHeight: "0!important",
    padding: "0",
  },

  "& .app-inner-container": {
    padding: "2rem",
    overflowY: "hidden",
    [theme.breakpoints.down("md")]: {
      padding: "1rem",
    },
  },

  "& #mobile-toolbar": {
    height: "70px",
    display: "flex",
    justifyContent: "space-between",
    padding: "15px",
    alignItems: "center",
    borderBottom: "1px solid transparent",
    borderImage: `linear-gradient(0.25turn, ${theme.palette.background.button_primary}, ${theme.palette.border.brand})`,
    borderImageSlice: 1,

    "& img": {
      width: "67px",
      height: "32px",
    },

    "& button": {
      background: "#021C64",
      border: 0,
      padding: "10px 10px 8px",
      borderRadius: "8px",
      cursor: "pointer",
      transition: "all 0.2s ease",

      "&:active": {
        backgroundColor: theme.palette.border.brand,
      },

      "& svg": {
        width: "24px",
        height: "24px",
      },
    },
  },
}));
